import React, { useMemo } from 'react';
import { FileText, Users, Clock, CheckCircle } from 'lucide-react';

const OnboardingStats = ({ templates, onboardingCases }) => {
  const stats = React.useMemo(() => {
    if (!onboardingCases || onboardingCases?.length === 0) {
      return {
        totalTemplates: templates?.length || 0,
        activeCases: 0,
        completedCases: 0,
        averageCompletion: 0
      };
    }

    const activeCases = onboardingCases?.filter(c => c?.status === 'in_progress')?.length;
    const completedCases = onboardingCases?.filter(c => c?.status === 'completed')?.length;
    const averageCompletion = onboardingCases?.reduce((sum, c) => sum + (c?.completionPercentage || 0), 0) / onboardingCases?.length;

    return {
      totalTemplates: templates?.length || 0,
      activeCases,
      completedCases,
      averageCompletion: Math.round(averageCompletion)
    };
  }, [templates, onboardingCases]);

  const statCards = [
    {
      title: 'Templates',
      value: stats?.totalTemplates,
      icon: FileText,
      color: 'bg-blue-500',
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-600'
    },
    {
      title: 'Active Cases',
      value: stats?.activeCases,
      icon: Clock,
      color: 'bg-orange-500',
      bgColor: 'bg-orange-50',
      textColor: 'text-orange-600'
    },
    {
      title: 'Completed',
      value: stats?.completedCases,
      icon: CheckCircle,
      color: 'bg-green-500',
      bgColor: 'bg-green-50',
      textColor: 'text-green-600'
    },
    {
      title: 'Avg. Progress',
      value: `${stats?.averageCompletion}%`,
      icon: Users,
      color: 'bg-purple-500',
      bgColor: 'bg-purple-50',
      textColor: 'text-purple-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {statCards?.map((stat) => (
        <div key={stat?.title} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center">
            <div className={`${stat?.bgColor} rounded-lg p-3 mr-4`}>
              <stat.icon className={`h-6 w-6 ${stat?.textColor}`} />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-600">{stat?.title}</p>
              <p className="text-2xl font-semibold text-gray-900">{stat?.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OnboardingStats;